window.Products.Accessory.DadCapWithPrintedPatch = function() {};
window.Products.Accessory.DadCapWithPrintedPatch.inherits(window.Products.Accessory.Accessory);